<fcom-modal
  [fitToContent]="true"
  [buttons]="ModalButtons.CUSTOM"
  [title]="'modal.genericTitle' | finLocalization"
  [(open)]="unsavedChangesModalOpen"
  (close)="this.continueEditing.emit()"
>
  <div>
    <h2 class="font-heading-4 pr-medium-x pr-medium-t pr-small-b bold-type nordic-blue-900-text">
      {{ 'MMB.unsavedChangesModal.header' | finLocalization }}
    </h2>
    <div class="font-body-1 pr-medium-x pr-small-b nordic-blue-900-text">
      {{ 'MMB.unsavedChangesModal.content' | finLocalization }}
    </div>
  </div>
  <div buttons>
    <fcom-button
      [text]="'MMB.unsavedChangesModal.leaveButton' | finLocalization"
      (clickBtn)="this.leaveWithoutSaving.emit()"
      [theme]="ButtonTheme.LIGHT_SECONDARY_OUTLINE"
      class="mr-xsmall-r"
    ></fcom-button>
    <fcom-button
      [text]="'MMB.unsavedChangesModal.continueButton' | finLocalization"
      (clickBtn)="this.continueEditing.emit()"
      [theme]="ButtonTheme.LIGHT_PRIMARY_NORDIC_BLUE"
      class="mr-xsmall-r"
    ></fcom-button>
  </div>
</fcom-modal>
